import { useState } from "react";
import organizerlogo from "../../svg/organizerlogo.png";
import würfel from "../../svg/würfel-3355073865.png";
import bifrost from "../../svg/bifrost.webp";
import bifrostBlack from "../../svg/bifrost-black.png";
import erasmus from "../../svg/erasmus.webp";

import { useTranslation } from "react-i18next";

const Footer = (props) => {
  const [showPolicy, setShowPolicy] = useState(false);
  const [t, ] = useTranslation("global");

  const ClickHandler = () => {
    setShowPolicy(!showPolicy);
  };

  let partnerTextColor = "white";
  let partnerLinkTextColor = "#4183ab";
  if (props.version === "school" || props.version === "academic") {
    partnerTextColor = "black";
    partnerLinkTextColor = "#00ac9f"
  }

  return (
    <>

      {(props.version === "users" || props.version === "school" || props.version === "academic") && (
        <>
          <div className="ml-24 mr-24">
            <div className="grid lg:grid-cols-4 gap-3 pb-10 container justify-items-center lg:justify-items-start">
                                <img
                  src={erasmus}
                  className="place-self-center w-64 bg-white mb-4 mt-4 
                            order-last lg:order-none"
                  alt="logo"
                />
              <div className="grid grid-cols-2 gap-4 pt-8 lg:justify-self-center">
                <img
                  src={organizerlogo}
                  className="place-self-center w-24"
                  alt="logo"
                />
                <div className="pt-8">
                  <div
                    style={{ fontFamily: "Poppins", color: partnerTextColor }}
                    className="text-left text-sm"
                  >
                    Dragon Legion
                  </div>
                  <div
                    style={{ fontFamily: "Poppins" }}
                    className="text-left text-sm"
                  >
                    <a style={{ color: partnerLinkTextColor }} href="https://dragon-legion.com">dragon-legion.com</a>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4 justify-self-center">
                <img
                  src={würfel}
                  className="place-self-center w-20 pb-2"
                  alt="logo"
                />
                <div className="pt-16">
                  <div
                    style={{ fontFamily: "Poppins", color: partnerTextColor  }}
                    className=" text-left text-sm"
                  >
                    Würfelpech e.V.
                  </div>
                  <div
                    style={{ fontFamily: "Poppins" }}
                    className=" text-left text-sm"
                  >
                    
                    <a style={{ color: partnerLinkTextColor }} href="https://wuerfelpech-halle.de">
                      wuerfelpech-halle.de
                    </a>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4 justify-self-center">
                {props.version === "users" && (
                  <img
                  src={bifrost}
                  className="place-self-center w-20 pb-2"
                  alt="logo"
                />
                )}
                {(props.version === "school" || props.version === "academic") && (
                  <img
                  src={bifrostBlack}
                  className="place-self-center w-20 pb-2"
                  alt="logo"
                />
                )}
                <div className="pt-16">
                  <div
                    style={{ fontFamily: "Poppins", color: partnerTextColor }}
                    className="text-left text-sm"
                  >
                    Landsforeningen Bifrost
                  </div>
                  <div
                    style={{ fontFamily: "Poppins" }}
                    className=" text-left text-sm"
                  >
                    <a className="break-all" style={{ color: partnerLinkTextColor }} href="https://landsforeningenbifrost.dk/">
                      landsforeningenbifrost.dk
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {props.version === "users" &&
           (
            <>
              <div
              style={{ fontFamily: "Poppins" }}
              className="text-lime-700 bg-white text-center text-sm justify-items-center py-4"
              onClick={ClickHandler}
              alt="button"
              >
                <a target="_blank" href="https://dragon-legion.com/disclaimer/" rel="noreferrer">{t("footer.disclaimer")}</a>
              </div>
              <div className="pt-2 bg-red-800"></div>
            </>
           )
          }

          {props.version === "academic" &&
           (
            <>
              <div
              style={{ fontFamily: "Poppins", backgroundColor:"#1acfbd" }}
              className="text-center text-sm justify-items-center py-4"
              onClick={ClickHandler}
              alt="button"
              >
                <a target="_blank" style={{ color: "white" }} href="https://dragon-legion.com/disclaimer/" rel="noreferrer">{t("footer.disclaimer")}</a>
              </div>
              <div className="pt-2 bg-white-800"></div>
            </>
           )
          }

          {props.version === "school" &&
           (
            <>
              <div
                style={{ fontFamily: "Poppins", backgroundColor: "#6832c7" }}
                className="text-center text-sm justify-items-center py-4"
                onClick={ClickHandler}
                alt="button"
              >
                <a target="_blank" style={{ color: "white" }} href="https://dragon-legion.com/disclaimer/" rel="noreferrer">{t("footer.disclaimer")}</a>
              </div>
               <div className="pt-2 bg-white-800"></div>
            </>
           )
          }
        </>
      )}
    </>
  );
};

export default Footer;
